import { ReactNode } from 'react';
import styled from 'styled-components';
import { lighten, rgba } from 'polished';

import CopyIconBase from '#/assets/CopyIcon';
import CheckmarkIconBase from '#/assets/CheckmarkIcon';

import { c00EE91, c14142E, cCC38FF, cFFFFFF } from '#/colors';

import * as walletFn from '#/features/wallet/functions';

import useCopyToClipboard from '#/utils/useCopyToClipboard';

interface Props {
  readonly address: string;
  readonly icon: ReactNode;
  readonly title: string;
}

export function AddressBlock({ address, icon, title }: Props) {
  const [copyToClipboard, status] = useCopyToClipboard(address);

  return (
    <Container onClick={copyToClipboard}>
      {icon}
      <div css="display: grid; gap: 6px;">
        <Title>{title}</Title>
        <Address>{walletFn.maskAccount(address)}</Address>
      </div>
      {status === 'idle' ? <CopyIcon size={17} /> : <CheckmarkIcon size={18} />}
    </Container>
  );
}

const Container = styled.button.attrs({ type: 'button' })`
  border: none;
  color: ${cFFFFFF};
  text-align: left;
  display: grid;
  align-items: center;
  grid-template-columns: auto 1fr auto;
  gap: 16px;
  padding: 0 16px;

  height: 56px;
  border-radius: 7px;
  background-color: ${c14142E};

  &:hover {
    background-color: ${lighten(0.03, c14142E)};
  }

  &:active {
    background-color: ${lighten(0.05, c14142E)};
  }
`;

const Title = styled.h2`
  color: ${rgba(cFFFFFF, 0.7)};
  font-size: 12px;
  font-weight: 500;
  line-height: 12px;
  margin: 0;
`;

const Address = styled.pre`
  font-size: 14px;
  font-weight: 500;
  line-height: 13px;
  margin: 0;
`;

const CopyIcon = styled(CopyIconBase)`
  color: ${cCC38FF};
`;

const CheckmarkIcon = styled(CheckmarkIconBase)`
  color: ${c00EE91};
`;
